import React, { useContext } from "react";
import intl from "react-intl-universal";
import commonUtils from "../../../script/utils/commonUtils";
import { mdiCalculator, mdiClose } from "@mdi/js";

import antennaRest from "../../../rest/antennaRest";
import calculationRest from "../../../rest/calculationRest";

import { Grid } from "../../components/Grid";
import { useInput } from "../../hooks/useInput";
import { Button } from "../../components/Button";
import { Spacer } from "../../components/Spacer";
import { Dialog } from "../../containers/Dialog";
import { Checkbox } from "../../components/Checkbox";
import { InputText } from "../../components/InputText";
import { DialogBody } from "../../containers/DialogBody";
import { useValidation } from "../../hooks/useValidation";
import { InputNumber } from "../../components/InputNumber";
import { DialogFooter } from "../../containers/DialogFooter";
import { ValidationContext } from "../../contexts/ValidationContext";

export const WorstcaseDataDialog = props => {
    const { antenna } = props;

    const validationContext = useContext(ValidationContext);

    const antennaName = useInput("antennaName", antenna.name);
    const apertureHeight = useInput("apertureHeight", antenna.apertureHeight);
    const worstcaseDataFarField = useInput("worstcaseDataFarField", true);

    useValidation(value => !commonUtils.isBlank(value), [apertureHeight]);

    const onWorstcaseData = async () => {
        const allValid = await validationContext.allValid();
        validationContext.setErrorsVisible(true);
        if (allValid) {
            antenna.apertureHeight = apertureHeight.value;
            await antennaRest.update(antenna);
            await calculationRest.worstcaseData(antenna.id, worstcaseDataFarField.value);
            props.onClose();
        }
    };

    return (
        <Dialog
            width="360px"
            title={intl.get("worstcaseData.calculateWorstcaseData")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <Grid columns="1">
                    <InputText {...antennaName.bind}
                        maxLength="50"
                        disabled={true}
                        title={intl.get("antennas.name")} />
                    <InputNumber {...apertureHeight.bind}
                        fractionDigits={3}
                        title={intl.get("antennas.apertureHeight")} />
                    <Checkbox {...worstcaseDataFarField.bind} title={intl.get("entry.wattwaechterSetting.preferFarField")} />
                </Grid>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiClose}
                    onClick={() => props.onClose()}
                    value={intl.get("common.cancel")} />
                <Spacer variant="vertical" />
                <Button
                    svgIcon={mdiCalculator}
                    onClick={() => onWorstcaseData()}
                    value={intl.get("worstcaseData.calculate")} />
            </DialogFooter>
        </Dialog>
    );
};